import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { Button, Flex, IconButton,Text } from '@chakra-ui/react';
import React from 'react';
import './pagination.css';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
    const resourceExist = totalPages > 0;
   const generatePageNumbers = () => {
     const pages = [];
     const delta = 2; // controls the range of pages around the current page
     const range = {
       start: Math.max(2, currentPage - delta),
       end: Math.min(totalPages - 1, currentPage + delta),
     };

     // Avoiding duplicate page numbers near the boundaries
     if (currentPage - delta > 2) {
       pages.push(1, '...');
     } else {
       for (let i = 1; i < range.start; i++) {
         pages.push(i);
       }
     }

     for (let i = range.start; i <= range.end; i++) {
       pages.push(i);
     }

     if (currentPage + delta < totalPages - 1) {
       pages.push('...', totalPages);
     } else {
       for (let i = range.end + 1; i <= totalPages; i++) {
         pages.push(i);
       }
     }

     return pages;
   };

  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        mt="1.5rem"
        pt={'1.25rem'}
        borderTop="1px solid"
        borderColor={'gray.200'}
        mb="7.69rem"
      >
      <Flex
          align={'center'}
          gap="0.5rem"
          justifyContent={'space-between'}
        >
          <IconButton
            aria-label="Previous page"
            icon={<ArrowBackIcon />}
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            variant="outline"
            isDisabled={currentPage === 1}
          />
          <Text
            fontSize={'0.875rem'}
            fontWeight={'600'}
            lineHeight={'1.25rem'}
            color={'gray.600'}
          >
            Previous
          </Text>
        </Flex>
        <Flex gap="0.13rem">
          {resourceExist && generatePageNumbers().map((number, index) => {
            if (number === '...') {
              return (
                <Text key={`ellipsis-${index}`} mx={2}>
                  ...
                </Text>
              );
            } else {
              return (
                <Button
                  key={number}
                  onClick={() => onPageChange(number as number)}
                  colorScheme="gray"
                  variant={currentPage === number ? 'solid' : 'ghost'}
                  size="sm"
                  color={
                    currentPage === number ? 'gray.800' : 'gray.600'
                  }
                  mx={1}
                >
                  {number}
                </Button>
              );
            }
          })}
        </Flex>

        <Flex
          align={'center'}
          gap="0.5rem"
          justifyContent={'space-between'}
        >
          <Text
            fontSize={'0.875rem'}
            fontWeight={'600'}
            lineHeight={'1.25rem'}
            color={'gray.600'}
          >
            Next
          </Text>
          <IconButton
            aria-label="Next page"
            icon={<ArrowForwardIcon />}
            onClick={() =>
              onPageChange(Math.min(totalPages, currentPage + 1))
            }
            isDisabled={currentPage === totalPages}
          />
        </Flex>
      </Flex>
    </>
  );
};

export default Pagination;